import { useCallback, useEffect, useState } from "react";
import { base } from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";

export const useRelatedProductSlider = () => {
  const { t } = useLocale();
  const { toIndianCurrency, showAlert, generateUID, isEmpty } =
    useService("Misc");
  const { addToCart: addToBasket } = useService("Order");
  const { getProduct } = useService("Product");
  const [featuredProducts, setfeaturedProducts] = useState([]);

  const getProductsData = useCallback(async () => {
    const result = await getProduct({ status: "publish" });
    if (result.status) {
      let tableData = [];
      result.data.forEach((e, i) => {
        if (typeof e.trash === "undefined" && i < 10) tableData.push(e);
        else if (!e.trash && i < 10) tableData.push(e);
      });
      setfeaturedProducts(tableData);
    }
  }, [getProduct]);
  const productAddedTemplate = useCallback(
    (item) => {
      let price = item.price;
      if (!isEmpty(item.saleprice)) {
        price = item.saleprice;
      }
      let prodcutAddedTemplate = `<div class="alert-msg"><i class="hi-checkbox-checked"></i><p>${t(
        "success.addToCart.product"
      )}</p></div>
        <div class="product-box">
        <Img src="${base.imageBaseUrl + item.image}" alt="${
        item.title
      }" class="product-image" />
        <div class="product-content">
        <p class="product-title">${item.title}</p>
        <p class="product-price">${toIndianCurrency(price)}</p>
        </div>
        </div>`;
      showAlert({
        type: "custom",
        template: prodcutAddedTemplate,
      });
    },
    [isEmpty, showAlert, t, toIndianCurrency]
  );

  const addToCart = useCallback(
    (item) => {
      let price = item.price,
        mrp = price,
        saleprice = item.saleprice;
      if (isEmpty(item.saleprice)) {
        price = saleprice;
      }
      const taxAmount = Number(
        ((price * Number(item.tax)) / (100 + Number(item.tax))).toFixed(2)
      );
      let product = {
        uid: item.uid,
        title: item.title,
        image: JSON.parse(item.image)[0],
        purchaseQuantity: 1,
        type: "product",
        tempUid: generateUID(),
        mrp: Number(mrp),
        saleprice,
        tax: item.tax,
        hsn: item.hsn,
        sku: item.sku,
        taxAmount,
        price: price - taxAmount,
        displayPrice: price,
      };
      addToBasket(product);
      productAddedTemplate(product);
    },
    [addToBasket, generateUID, isEmpty, productAddedTemplate]
  );

  useEffect(() => {
    getProductsData();
  }, [getProductsData]);
  return {
    featuredProducts,
    addToCart,
  };
};
